<template>
    <div id="labelAutocomplete">
        <v-combobox
            placeholder="Catatan soal"
            :items="filteredLabels"
            outlined
            maxlength="255"
        >
            <template v-slot:item="{ item }">
                <a href="javascript:;" @click="$emit('selected', item)">{{
                    item
                }}</a>
            </template>
        </v-combobox>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "label-autocomplete",

    data: function () {
        return {
            labels: [],
        };
    },

    props: {
        query: {
            type: String,
            default: "",
        },
    },

    computed: {
        filteredLabels: function () {
            if (this.query === null || this.query.length < 3) return [];

            var results = [];
            var context = this;
            this.labels.forEach(function (label) {
                var query = context.query.toUpperCase();
                var target = label.toUpperCase();

                if (target.indexOf(query) != -1) results.push(label);
            });

            return results;
        },
    },

    beforeMount: function () {
        var url = process.env.API_BASE_URL + "/itembank/labels";
        var authToken = JSON.parse(localStorage.getItem("token")).value;
        var options = {
            headers: {
                Authorization: "Bearer " + authToken,
            },
        };

        var context = this;
        axios.get(url, options).then(function (response) {
            if (response.status === 200) {
                response.data.forEach(function (d) {
                    context.labels.push(d);
                });
            }
        });
    },
};
</script>



// WEBPACK FOOTER //
// LabelAutocomplete.vue?520b9f6c